export const standardTransitionDuration = "300ms";
export const standardTransitionTimingFunction = "ease-out";

export const colorTransitionDuration = standardTransitionDuration;
export const colorTransitionTimingFunction = standardTransitionTimingFunction;
export const colorTransition = "color " + colorTransitionDuration + " " + colorTransitionTimingFunction;

export default colorTransition;